
const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { Component, Vue, Watch } from 'vue-property-decorator';

import { mainStore } from '../_store/main';

import { ShapeKeys, PointCloudDefinition } from '../_modules/webgl/PointCloud';

import PageComponent from '../_modules/PageComponent';
import MainGL from '../_modules/webgl/MainGL';

const CompanyScrollState = {
  KV: 'KV',
  CONTACT: 'CONTACT',
} as const;

export const CompanyGLDefinition: PointCloudDefinition = {
  KV: {
    key: 'KV',
    shapeKey: 'KV',
    isKV: true,
    order: 0,
    kvItems: [
      { key: '', shapeKey: ShapeKeys.LOGO, order: 0 },
   ]
  },
  CONTACT : { key: 'CONTACT' , shapeKey: ShapeKeys.CONTACT , order: 1 },
};


export default class Main extends PageComponent {
  protected memberEl!: HTMLElement;

  constructor() {
    super();
    this.init();
  }

  get isKV      () { return this.scrollState === CompanyScrollState.KV      }
  get isContact () { return this.scrollState === CompanyScrollState.CONTACT }

  protected async initObservers() {
    await this.wait(400);

    this.initPageKVObserver();
    this.initContactLinkObserver();
  }

  protected async init(): Promise<void> {
    mainStore.setCurrentPageId('company');

    this.scrollToTweenObj = { value: window.scrollY || window.pageYOffset };

    await Promise.all([
      g.loadFontPromise,
      this.initMainGL(),
      this.initLoading(),
      this.initHeader(),
      this.initFooter(),
      this.initMenu(),
    ]);

    await this.initContents();

    this.initMediaQuery();
    this.initScroll();
    this.initResize();

    this.resizeHandler();

    mainStore.setScrolled(false);
    mainStore.setLoaded(true);

    this.initObservers();

    await this.pageKV.$nextTick();

    this.isLocked = false;
    this.onScroll();
    this.onResize();
    this.play();
  }

  protected async initContents(): Promise<void> {
    await Promise.all([
      this.initPageKV(),
      this.initContact(),
    ]);

    await super.initContents();
  }

  protected async initMainGL() {
    const mainGLEl = this.bodyElm.querySelector('.js-mainGL') as HTMLElement;

    this.mainGL = new MainGL<typeof CompanyGLDefinition>(
      mainGLEl,
      mainGLEl.querySelector('canvas') as HTMLCanvasElement,
      CompanyGLDefinition,
      'KV',
      false
    );

    await this.mainGL.init()
    .catch((e)=> {
      console.log(e);
      this.htmlElm.classList.add('is-noWebGL');
      mainStore.setNoWebGL(true);
    })
    this.mainGL.onResize();
  }

  protected async onResize() {
    console.log('onResize');
    setTimeout(()=> {
      this.mainGL.onResize();
      this.updateGLScales();
    }, 10);
  }

  protected onScroll(): void {
    super.onScroll();
    this.mainGL.setScrollTop();
    this.pageKV.getImgContainer().style.top = `calc(50% + ${mainStore.scrollTop}px)`;
    this.updateGLScales();
  }

  protected updateGLScales() {
    const kvImgEl = this.pageKV.getImgContainer()

    this.mainGL.setParams({
      KV: {
        imgSize: kvImgEl.offsetWidth || 1,
        offset: this.getOffsetImgItem(kvImgEl, true),
      },
      CONTACT: {
        imgSize: this.contactLinkImgEl.offsetWidth,
        offset: this.getOffsetImgItem(this.contactLinkImgEl)
      },
    })
  }

  public play(): void {
    super.play();

    this.mainGL.startLoop();
    this.updateGLScales();

    this.mainGL.play(()=> {
      this.isLocked = false;
      this.mainGL.setMode('KV');
      this.mainGL.setKVIndex(0);
      this.pageKV.play();
    }, false);
  }

  protected initContactLinkObserver() {
    if(!window.IntersectionObserver || g.isGoogleBot) return;

    this.contactLinkObserver = new IntersectionObserver((entries)=> {
      const entry = entries[0];
      if(entry.isIntersecting) {
        if(this.scrollState === '' || (!this.isContact && this.scrollDir === 1)) {
          this.scrollState = CompanyScrollState.CONTACT;
          console.log('scroll state:', CompanyScrollState.CONTACT);
          this.mainGL.setMode(CompanyScrollState.CONTACT);
        }

        if(this.scrollDir === 1) {
          this.bodyElm.classList.remove('is-orangeBg');
          this.mainGL.setOrange(false);
        }
      } else {
        if(this.isContact && this.scrollDir === -1) {
          this.scrollState = CompanyScrollState.KV;
          console.log('scroll state:', CompanyScrollState.KV);
          this.mainGL.setMode(CompanyScrollState.KV);
        }
      }
    }, {
      threshold: [0, 1],
      rootMargin: '-30% 0px'
    });
    this.contactLinkObserver.observe(this.contactLinkEl);
  }
}